import { addDays, subDays, parse } from 'date-fns'
import { formatDate, getValidatedImages } from '@/helpers'
import { OPPORTUNITY__BRANDS } from "@/constants";

export default {
  SET_OPPORTUNITY_DETAILS_DATA (state, data) {
    const opportunityDetails = data.data.opportunityDetails

    let brands = []
    let types = []
    let stages = []
    let suppliers = []
    let regions = []
    let owner = null
    let users = [];

    if (Array.isArray(opportunityDetails.brands) && opportunityDetails.brands.length > 0) {
      brands = opportunityDetails.brands
        .filter(t => t.id !== null)
        .map(t => ({ text: t.text, value: t.id }))
    }

    if (Array.isArray(opportunityDetails.types) && opportunityDetails.types.length > 0) {
      types = opportunityDetails.types
        .filter(t => t.id !== null)
        .map(t => ({ text: t.text, value: t.id, brands: t.brand_ids }))
    }

    if (Array.isArray(opportunityDetails.stages) && opportunityDetails.stages.length > 0) {
      stages = opportunityDetails.stages
        .filter(t => t.id !== null)
        .map(t => ({ text: t.text, value: t.id }))
    }

    if (Array.isArray(opportunityDetails.supplier) && opportunityDetails.supplier.length > 0) {
      suppliers = opportunityDetails.supplier
        .filter(t => t.id !== null)
        .map(t => ({ text: t.text, value: t.id }))
    }

    if (Array.isArray(opportunityDetails.regions) && opportunityDetails.regions.length > 0) {
      regions = opportunityDetails.regions
        .filter(t => t.id !== null)
        .map(t => ({ text: t.text, value: t.id }))
    }

    owner = opportunityDetails.owner

    if (Array.isArray(opportunityDetails.users))
      users = opportunityDetails.users;

    state.opportunityDetails = {
      brands,
      types,
      stages,
      suppliers,
      regions,
      owner,
      users,
    }
  },

  SET_CLIENT_DETAILS_DATA (state, data) {
    const opportunityDetails = data.data.clientDetails

    let types = []

    if (Array.isArray(opportunityDetails.types) && opportunityDetails.types.length > 0) {
      types = opportunityDetails.types
        .filter(t => t.id !== null)
        .map(t => ({ text: t.text, value: t.id }))
    }

    state.clientDetails = {
      types
    }
  },

  SET_OPPORTUNITY_STATUS_DATA (state, data) {
    state.opportunityStatus = data.data.opportunityStatus
  },

  SET_FORMAT_TYPES_DATA (state, data) {
    state.formatTypes = data.data.formatTypes
      .map(f => ({ text: f.text, value: f.id }))
  },

  SET_STEP_SELECT_DATA (state, data) {
    const stepSelectData = data.data

    let brands = []
    let themes = []

    if (Array.isArray(stepSelectData.brands) && stepSelectData.brands.length > 0) {
      const trBrand = state.opportunityDetails.brands.find(b => b.value === OPPORTUNITY__BRANDS.TRAFALGAR_RIVER);

      brands = stepSelectData.brands
        .filter(t => t.id !== null)
        .filter(t => trBrand || t.id !== OPPORTUNITY__BRANDS.TRAFALGAR_RIVER)
        .map(t => ({ text: t.text, value: t.id }))
    }

    if (Array.isArray(stepSelectData.themes) && stepSelectData.themes.length > 0) {
      themes = stepSelectData.themes
        .filter(t => t.id !== null)
        .map(t => ({ text: t.text, value: t.id }))
    }

    state.stepSelectData = {
      brands,
      themes
    }
  },

  SET_PERMISSIONS_DATA (state, data) {
    state.permissionsData = data.permissions
  },

  SAVE_NEWOPPORTUNITY (state, payload) {
    state.newOpportunity = payload
  },

  TMP_SAVE_OPPORTUNITY_DETAILS (state, payload) {
    const data = {
      details: payload.opportunityDetailsTab,
      client: payload.clientInformationTab,
      request: payload.quoteRequestTab,
      sections: payload.sections
    }

    // ItinerarySelect
    const indexItinerary = state.itinerarySourceTypeSelected.index

    state.opportunity.reference_number = data.details.referenceNumber
    state.opportunity.opportunity_name = data.details.opportunityName
    state.opportunity.itineraries[indexItinerary].titleitinerary = data.details.opportunityName
    state.opportunity.departure_date = data.details.departureDate || null
    state.opportunity.id_owner = data.details.ownerId

    state.opportunity.properties_opportunity.id_brand = Number(data.details.brandId)
    state.opportunity.properties_opportunity.id_opportunity_export_type = Number(data.details.typeId)

    state.opportunity.selling_regions = [{ id: Number(data.details.regionId), order: 0 }]

    state.opportunity.client_details.phone_number = data.client.phoneNumber
    state.opportunity.client_details.account_email = data.client.email
    state.opportunity.client_details.account_address = data.client.address
    state.opportunity.client_details.contact_name = data.client.contactName
    state.opportunity.client_details.account_name = data.client.accountName
    state.opportunity.client_details.properties_client.id_type_client = Number(data.client.typeId)

    state.opportunity.request_form.foc_places = data.request.focPlaces
    state.opportunity.request_form.quote_deadline = data.request.quoteDeadline
    state.opportunity.request_form.budget = data.request.budget ? data.request.budget : ''
    state.opportunity.request_form.percentage_commission = Number(data.request.commission)
    state.opportunity.request_form.airport_arrive = data.request.arrivalAirportPort
    state.opportunity.request_form.airport_departure = data.request.departureAirportPort
    state.opportunity.request_form.price_break = data.request.priceBreak
    state.opportunity.request_form.hotel_standard = Number(data.request.hotelStandard)
    state.opportunity.request_form.additional_information = data.request.additionalInformation
    state.opportunity.request_form.difficult_dates_checked = Number(data.request.difficultDatesChecked)
    state.opportunity.request_form.prebookings_required = Number(data.request.prebookingsRequired)
    state.opportunity.request_form.flourishes_local_treats = Number(data.request.flourishesLocalTreats)
    state.opportunity.request_form.gratuities_for_td_driver = Number(data.request.gratuitiesForTdDriver)
    state.opportunity.request_form.td_offer_optionals = Number(data.request.tdOfferOptionals)
    state.opportunity.request_form.repeat_guest_gift = Number(data.request.repeatGuestGift)
    state.opportunity.request_form.including_local_guides = Number(data.request.includingLocalGuides)
    state.opportunity.request_form.birthday_allowance = Number(data.request.birthdayAllowance)
    state.opportunity.request_form.group_photo = Number(data.request.groupPhoto)
    state.opportunity.request_form.properties_request_form.id_supplier = Number(data.request.supplierId)
    state.opportunity.request_form.properties_request_form.id_stage_supplier = Number(data.request.stageId)
    state.opportunity.request_form.properties_request_form.id_guests = Number(data.request.guests)
    state.opportunity.request_form.properties_request_form.id_additional_doc = 0

    state.opportunity.itineraries[indexItinerary].letter_itinerary = data.sections.letter
    state.opportunity.itineraries[indexItinerary].pricing_itinerary = data.sections.pricing
    state.opportunity.itineraries[indexItinerary].pricing_agent_itinerary = data.sections.agentPricing
    state.opportunity.itineraries[indexItinerary].terms_conditions = data.sections.termsAndConditions
    state.opportunity.itineraries[indexItinerary].consumer_terms_conditions = data.sections.consumerTermsAndConditions
    state.opportunity.itineraries[indexItinerary].book_group = data.sections.bookMyGroup
    state.opportunity.itineraries[indexItinerary].air_contract = data.sections.airContract

    // Validation: setting days[n].textday to [ { textday_ '' } ] if is empty or null.
    // TODO: Move this logic to other place
    const days = state.opportunity.itineraries[indexItinerary].days

    if (days.length > 0) {
      days.map((day, index) => {
        const currentTextDay = state.opportunity.itineraries[indexItinerary].days[index].textday
        if (currentTextDay === '' || currentTextDay === null) {
          state.opportunity.itineraries[indexItinerary].days[index].textday = [{ textday: '' }]
        }
      })
    }
  },

  TMP_SAVE_OPPORTUNITY_GUEST_DOCUMENTATION (state, payload) {
    if (!state.opportunity.guest_documentation) {
      state.opportunity.guest_documentation = {}
      state.opportunity.guest_documentation.id = null
      state.opportunity.guest_documentation.introduction = ''
      state.opportunity.guest_documentation.optional_experience = ''
      state.opportunity.guest_documentation.hotel_list = ''
      state.opportunity.guest_documentation.images = {
        id: null,
        background: [],
        cover_page: [],
        cover_video: [],
        images_page: []
      }
    }

    state.opportunity.guest_documentation.introduction = payload.guestDocumentation.introduction
    state.opportunity.guest_documentation.optional_experience = payload.guestDocumentation.optionalExperience
    state.opportunity.guest_documentation.hotel_list = payload.guestDocumentation.hotelList

    if (state.opportunity.guest_documentation && !state.opportunity.guest_documentation.images) {
      state.opportunity.guest_documentation.images = {
        id: null,
        background: [],
        cover_page: [],
        cover_video: [],
        images_page: []
      }
    }
  },

  TMP_SAVE_OPPORTUNITY_CONSUMER_SECTION (state, payload) {
    const data = { consumer: payload.consumerSection }

    if (!state.opportunity.consumer_section) {
      state.opportunity.consumer_section = {}
      state.opportunity.consumer_section.id = null
      state.opportunity.consumer_section.images = {
        id: null,
        background: [],
        cover_page: [],
        cover_video: [],
        images_page: []
      }
      state.opportunity.consumer_section.highlights = []
      state.opportunity.consumer_section.whatsincluded = []
    }

    state.opportunity.consumer_section.call_action = data.consumer.yourDetails.callToAction
    state.opportunity.consumer_section.tour_host_name = data.consumer.yourDetails.tourHostName
    state.opportunity.consumer_section.tour_host_position = data.consumer.yourDetails.tourHostPosition

    state.opportunity.consumer_section.trip_name = data.consumer.tripDetails.tripName
    state.opportunity.consumer_section.trip_subtitle = data.consumer.tripDetails.tripSubtitle
    state.opportunity.consumer_section.company_name = data.consumer.tripDetails.companyName
    state.opportunity.consumer_section.twinshare_price = data.consumer.tripDetails.twinsharePrice
    state.opportunity.consumer_section.twinshare_price_name = data.consumer.tripDetails.twinsharePriceName
    state.opportunity.consumer_section.single_supp_price = data.consumer.tripDetails.singleSuppPrice
    state.opportunity.consumer_section.single_supp_price_name = data.consumer.tripDetails.singleSuppPriceName
    state.opportunity.consumer_section.short_description = data.consumer.tripDetails.shortDescription
    state.opportunity.consumer_section.terms_conditions = data.consumer.tripDetails.termsAndConditions

    if (state.opportunity.consumer_section && !state.opportunity.consumer_section.images) {
      state.opportunity.consumer_section.images = {
        id: null,
        background: [],
        cover_page: [],
        cover_video: [],
        images_page: []
      }
    }

    if (state.opportunity.consumer_section && !state.opportunity.consumer_section.highlights) {
      state.opportunity.consumer_section.highlights = []
    }

    if (state.opportunity.consumer_section && !state.opportunity.consumer_section.whatsincluded) {
      state.opportunity.consumer_section.whatsincluded = []
    }
  },

  SET_OPPORTUNITY_DATA (state, payload) {
    if (payload && payload.request_form && !payload.request_form.budget) {
      payload.request_form.budget = ''
    }
    state.opportunity = { ...payload }
    state.opportunitySource = { ...payload }
  },

  SET_OPPORTUNITY_BACKUP (state, payload) {
    state.opportunityBackup = JSON.parse(JSON.stringify(payload))
  },

  SET_OPPORTUNITIES_SAVED_DATA (state, payload) {
    state.opportunitiesSaved = payload
  },

  SET_SEARCH_DATA (state, payload) {
    state.search = payload
  },

  TEMP_SAVE_DAY (state, payload) {
    const indexItinerary = state.itinerarySourceTypeSelected.index
    const dayId = payload.id

    if (state.opportunity && state.opportunity.itineraries && state.opportunitySource && state.opportunitySource.itineraries) {
      const sourceDay = state.opportunitySource.itineraries[indexItinerary].days
        .filter(day => dayId ? dayId === day.id : payload.startdate === day.startdate).shift()

      sourceDay.title = payload.title
      if (sourceDay.textday && sourceDay.textday[0]) {
        sourceDay.textday[0].textday = payload.textday
      } else {
        sourceDay.textday = [{ textday: payload.textday }]
      }
      sourceDay.idimagen = payload.idimagen
      sourceDay.accommodation = payload.accommodation
      sourceDay.meals = payload.meals.filter(function (value) {
        return value.mealsday !== ''
      })
      // NOTE: We don't modify locations here, because
      // I need to add a status = -1 then I prefer make it separately in REMOVE_LOCATION mutation

      // TODO: This was cloned from TMP_SAVE_OPPORTUNITY_DETAILS, I need to crete a reusable function.
      const days = state.opportunity.itineraries[indexItinerary].days
      if (days.length > 0) {
        days.map((day, index) => {
          const currentTextDay = state.opportunity.itineraries[indexItinerary].days[index].textday
          if (currentTextDay === '' || currentTextDay === null) {
            state.opportunity.itineraries[indexItinerary].days[index].textday = [{ textday: '' }]
          }
        })
      }
    }
  },

  TEMP_REFRESH_ORDER_DAYS (state, payload) {
    const indexItinerary = state.itinerarySourceTypeSelected.index
    let counter = 0
    state.opportunitySource.itineraries[indexItinerary].days.forEach((day, index) => {
      const sourceDay = state.opportunitySource.itineraries[indexItinerary].days[index]
      counter = counter + 1
      sourceDay.startday = counter
    })
  },

  TEMP_REFRESH_DATE_DAYS (state, payload) {
    const indexItinerary = state.itinerarySourceTypeSelected.index
    const sourceFromItinerary = state.opportunitySource.itineraries[indexItinerary]['fromitinerary']
    let tempDate = parse(sourceFromItinerary, 'yyyyy-MM-dd', new Date())

    state.opportunitySource.itineraries[indexItinerary].days.forEach((day, index) => {
      const sourceDay = state.opportunitySource.itineraries[indexItinerary].days[index]
      if (index > 0) {
        sourceDay.startdate = formatDate(addDays(tempDate, 1))
        tempDate = parse(sourceDay.startdate, 'yyyyy-MM-dd', new Date())
      } else {
        sourceDay.startdate = formatDate(tempDate)
      }
    })
    //    const indexItinerary = state.itinerarySourceTypeSelected.index
    //    state.opportunitySource.itineraries[indexItinerary].days.forEach((day, index) => {
    //      const sourceDay = state.opportunitySource.itineraries[indexItinerary].days[index]
    //      const parsedDate = parse(sourceDay.startdate, 'yyyyy-MM-dd', new Date())
    //      if (index > payload.index) {
    //        sourceDay.startdate = formatDate(addDays(parsedDate, 1))
    //      }
    //    })
  },

  TEMP_UPDATE_FROMITINERARY (state, amount = 1) {
    const indexItinerary = state.itinerarySourceTypeSelected.index
    if (state.opportunitySource &&
      state.opportunitySource.itineraries[indexItinerary] &&
      state.opportunitySource.itineraries[indexItinerary]['itinerary_source_type'] === 121) {
      //
    } else {
      const sourceFromItinerary = state.opportunitySource.itineraries[indexItinerary]['fromitinerary']
      const parsedFromItinerary = parse(sourceFromItinerary, 'yyyyy-MM-dd', new Date())
      state.opportunitySource.itineraries[indexItinerary]['fromitinerary'] = formatDate(subDays(parsedFromItinerary, amount))
    }
  },

  TEMP_ADD_DAY (state, payload) {
    const indexItinerary = state.itinerarySourceTypeSelected.index
    const newIndex = payload.index + 1
    if (state.opportunitySource &&
      state.opportunitySource.itineraries[indexItinerary] &&
      Array.isArray(state.opportunitySource.days) &&
      state.opportunitySource.days.length > 0) {
      state.opportunitySource.itineraries[indexItinerary].days
        .splice(newIndex, 0, payload.day)
    } else {
      if (!state.opportunitySource.itineraries[indexItinerary].days) {
        state.opportunitySource.itineraries[indexItinerary].days = []
      }
      state.opportunitySource.itineraries[indexItinerary].days.splice(newIndex, 0, payload.day)
    }
  },

  TEMP_FILL_DAY_REGULAR (state, payload) {
    const indexItinerary = state.itinerarySourceTypeSelected.index
    const index = payload.index
    state.opportunitySource.itineraries[indexItinerary].days.splice(index, 1, payload.day)
  },

  TEMP_FILL_DAY (state, payload) {
    const indexItinerary = state.itinerarySourceTypeSelected.index
    const index = payload.index
    if (payload.day.id === null) { // New day
      state.opportunitySource.itineraries[indexItinerary].days.splice(index, 1, payload.day)
    } else { // Existing day
      let sourceDay = state.opportunitySource.itineraries[indexItinerary].days[index]
      sourceDay.status = -1
      state.opportunitySource.itineraries[indexItinerary].days.splice(index, 0, payload.day)
      state.opportunitySource.itineraries[indexItinerary].days[index].id = null
    }
  },

  TEMP_REMOVE_DAY (state, payload) {
    const indexItinerary = state.itinerarySourceTypeSelected.index
    if (payload.indexDay > -1) {
      const sourceDay = state.opportunitySource.itineraries[indexItinerary].days[payload.indexDay]
      if (payload.isANewDay) {
        state.opportunitySource.itineraries[indexItinerary].days.splice(payload.indexDay, 1)
      } else {
        sourceDay.status = -1
      }
    }
  },

  TEMP_ADD_LOCATION (state, payload) {
    const indexItinerary = state.itinerarySourceTypeSelected.index
    const { locationId, indexDay, name = '', order = 1 } = payload
    if (indexDay > -1) {
      if (state.opportunitySource.itineraries[indexItinerary].days[indexDay].locations === null) {
        state.opportunitySource.itineraries[indexItinerary].days[indexDay].locations = []
      }
      state.opportunitySource.itineraries[indexItinerary].days[payload.indexDay].locations
        .push({ id: locationId, name, order })
    }
  },

  TEMP_REMOVE_LOCATION (state, payload) {
    const indexItinerary = state.itinerarySourceTypeSelected.index
    if (payload.indexDay > -1) {
      state.opportunitySource.itineraries[indexItinerary].days[payload.indexDay].locations
        .filter(location => location.id === payload.locationId)
        .forEach((sourceLocation) => {
          sourceLocation.status = -1;
        })
    }
  },

  TOGGLE_REORDERING_ITINERARY (state) {
    state.isReorderingItinerary = !state.isReorderingItinerary
  },

  TEMP_REORDER_ITINERARY (state, payload) {
    const indexItinerary = state.itinerarySourceTypeSelected.index
    state.opportunitySource.itineraries[indexItinerary].days = payload
  },

  TEMP_REMOVE_HIGHLIGHT (state, data) {
    // ItinerarySelect
    const indexItinerary = state.itinerarySourceTypeSelected.index

    const highlights = state.opportunity[data.dataRootKey][indexItinerary].highlights
    var toDelete = highlights.findIndex(i => i.id === Number(data.id))
    if (toDelete === -1) {
      toDelete = highlights.findIndex(i => String(i.title) === String(data.title))
    }
    if (toDelete > -1) {
      highlights[toDelete].id ? highlights[toDelete].status = -1 : highlights.splice(toDelete, 1)
    }
  },

  TEMP_REMOVE_HIGHLIGHT_SALES_FLYER (state, data) {
    const highlights = state.opportunity[data.dataRootKey].highlights
    var toDelete = highlights.findIndex(i => i.id === Number(data.id))
    if (toDelete === -1) {
      toDelete = highlights.findIndex(i => String(i.title) === String(data.title))
    }
    if (toDelete > -1) {
      highlights[toDelete].id ? highlights[toDelete].status = -1 : highlights.splice(toDelete, 1)
    }
  },

  TEMP_REMOVE_INCLUDED (state, data) {
    // ItinerarySelect
    const indexItinerary = state.itinerarySourceTypeSelected.index

    const whatsIncluded = state.opportunity[data.dataRootKey][indexItinerary].whatsincluded
    var toDelete = whatsIncluded.findIndex(i => i.id === Number(data.id))
    if (toDelete === -1) {
      toDelete = whatsIncluded.findIndex(i => String(i.title) === String(data.title))
    }
    if (toDelete > -1) {
      whatsIncluded[toDelete].id ? whatsIncluded[toDelete].status = -1 : whatsIncluded.splice(toDelete, 1)
    }
  },

  TEMP_REMOVE_INCLUDED_SALES_FLYER (state, data) {
    const whatsIncluded = state.opportunity[data.dataRootKey].whatsincluded
    var toDelete = whatsIncluded.findIndex(i => i.id === Number(data.id))
    if (toDelete === -1) {
      toDelete = whatsIncluded.findIndex(i => String(i.title) === String(data.title))
    }
    if (toDelete > -1) {
      whatsIncluded[toDelete].id ? whatsIncluded[toDelete].status = -1 : whatsIncluded.splice(toDelete, 1)
    }
  },

  TEMP_REMOVE_NOT_INCLUDED (state, data) {
    // ItinerarySelect
    const indexItinerary = state.itinerarySourceTypeSelected.index

    const whatsNotIncluded = state.opportunity[data.dataRootKey][indexItinerary].whatsnotincluded
    var toDelete = whatsNotIncluded.findIndex(i => i.id === Number(data.id))
    if (toDelete === -1) {
      toDelete = whatsNotIncluded.findIndex(i => String(i.title) === String(data.title))
    }
    if (toDelete > -1) {
      whatsNotIncluded[toDelete].id ? whatsNotIncluded[toDelete].status = -1 : whatsNotIncluded.splice(toDelete, 1)
    }
  },

  TEMP_REMOVE_NOT_INCLUDED_SALES_FLYER (state, data) {
    const whatsNotIncluded = state.opportunity[data.dataRootKey].whatsnotincluded
    var toDelete = whatsNotIncluded.findIndex(i => i.id === Number(data.id))
    if (toDelete === -1) {
      toDelete = whatsNotIncluded.findIndex(i => String(i.title) === String(data.title))
    }
    if (toDelete > -1) {
      whatsNotIncluded[toDelete].id ? whatsNotIncluded[toDelete].status = -1 : whatsNotIncluded.splice(toDelete, 1)
    }
  },

  TEMP_SAVE_HIGHLIGHT (state, data) {
    // ItinerarySelect
    const indexItinerary = state.itinerarySourceTypeSelected.index

    if (!state.opportunity[data.dataRootKey][indexItinerary].highlights) {
      state.opportunity[data.dataRootKey][indexItinerary].highlights = []
    }
    state.opportunity[data.dataRootKey][indexItinerary].highlights.push({
      id: null,
      title: data.title,
      items: data.items,
      old: data.old
    })
  },

  TEMP_SAVE_HIGHLIGHT_SALES_FLYER (state, data) {
    if (!state.opportunity[data.dataRootKey].highlights) {
      state.opportunity[data.dataRootKey].highlights = []
    }
    state.opportunity[data.dataRootKey].highlights.push({
      id: null,
      title: data.title,
      items: data.items,
      old: data.old
    })
  },

  TEMP_SAVE_INCLUDED (state, data) {
    // ItinerarySelect
    const indexItinerary = state.itinerarySourceTypeSelected.index

    if (!state.opportunity[data.dataRootKey][indexItinerary].whatsincluded) {
      state.opportunity[data.dataRootKey][indexItinerary].whatsincluded = []
    }
    state.opportunity[data.dataRootKey][indexItinerary].whatsincluded.push({
      id: null,
      title: data.title,
      items: data.items,
      old: data.old
    })
  },

  TEMP_SAVE_INCLUDED_SALES_FLYER (state, data) {
    if (!state.opportunity[data.dataRootKey].whatsincluded) {
      state.opportunity[data.dataRootKey].whatsincluded = []
    }
    state.opportunity[data.dataRootKey].whatsincluded.push({
      id: null,
      title: data.title,
      items: data.items,
      old: data.old
    })
  },

  TEMP_SAVE_NOT_INCLUDED (state, data) {
    // ItinerarySelect
    const indexItinerary = state.itinerarySourceTypeSelected.index

    if (!state.opportunity[data.dataRootKey][indexItinerary].whatsnotincluded) {
      state.opportunity[data.dataRootKey][indexItinerary].whatsnotincluded = []
    }
    state.opportunity[data.dataRootKey][indexItinerary].whatsnotincluded.push({
      id: null,
      title: data.title,
      items: data.items,
      old: data.old
    })
  },

  TEMP_SAVE_NOT_INCLUDED_SALES_FLYER (state, data) {
    if (!state.opportunity[data.dataRootKey].whatsnotincluded) {
      state.opportunity[data.dataRootKey].whatsnotincluded = []
    }
    state.opportunity[data.dataRootKey].whatsnotincluded.push({
      id: null,
      title: data.title,
      items: data.items,
      old: data.old
    })
  },

  TEMP_UPDATE_INCLUDED (state, data) {
    // ItinerarySelect
    const indexItinerary = state.itinerarySourceTypeSelected.index

    var parentBlock
    switch (data.status) {
      case 'Highlights':
        parentBlock = state.opportunity[data.dataRootKey][indexItinerary].highlights
        break

      case 'Included':
        parentBlock = state.opportunity[data.dataRootKey][indexItinerary].whatsincluded
        break

      case 'Not Included':
        parentBlock = state.opportunity[data.dataRootKey][indexItinerary].whatsnotincluded
        break

      default:
        break
    }
    var toUpdate = parentBlock.find(i => i.id === Number(data.id))
    if (!toUpdate) {
      toUpdate = parentBlock.find(i => String(i.old) === String(data.old))
    }
    toUpdate.title = data.title
    toUpdate.items = data.items
  },

  TEMP_UPDATE_INCLUDED_SALES_FLYER (state, data) {
    var parentBlock
    switch (data.status) {
      case 'Highlights':
        parentBlock = state.opportunity[data.dataRootKey].highlights
        break

      case 'Included':
        parentBlock = state.opportunity[data.dataRootKey].whatsincluded
        break

      case 'Not Included':
        parentBlock = state.opportunity[data.dataRootKey].whatsnotincluded
        break

      default:
        break
    }
    var toUpdate = parentBlock.find(i => i.id === Number(data.id))
    if (!toUpdate) {
      toUpdate = parentBlock.find(i => String(i.old) === String(data.old))
    }
    toUpdate.title = data.title
    toUpdate.items = data.items
  },

  TEMP_SAVE_ITEM (state, data) {
    // ItinerarySelect
    const indexItinerary = state.itinerarySourceTypeSelected.index

    var parentBlock
    switch (data.status) {
      case 'Highlights':
        parentBlock = state.opportunity[data.dataRootKey][indexItinerary].highlights
        break

      case 'Included':
        parentBlock = state.opportunity[data.dataRootKey][indexItinerary].whatsincluded
        break

      case 'Not Included':
        parentBlock = state.opportunity[data.dataRootKey][indexItinerary].whatsnotincluded
        break

      default:
        break
    }
    var current = parentBlock.find(b => b.id === Number(data.id))
    if (!current) {
      current = parentBlock.find(b => String(b.old) === String(data.old))
    }
    current.items.push({
      id: null,
      items: 'Untitled new item-' + (current.items.length + 1),
      old: current.items.length + 1
    })
  },

  TEMP_SAVE_ITEM_SALES_FLYER (state, data) {
    var parentBlock
    switch (data.status) {
      case 'Highlights':
        parentBlock = state.opportunity[data.dataRootKey].highlights
        break

      case 'Included':
        parentBlock = state.opportunity[data.dataRootKey].whatsincluded
        break

      case 'Not Included':
        parentBlock = state.opportunity[data.dataRootKey].whatsnotincluded
        break

      default:
        break
    }
    var current = parentBlock.find(b => b.id === Number(data.id))
    if (!current) {
      current = parentBlock.find(b => String(b.old) === String(data.old))
    }
    current.items.push({
      id: null,
      items: 'Untitled new item-' + (current.items.length + 1),
      old: current.items.length + 1
    })
  },

  TEMP_REMOVE_ITEM (state, data) {
    // ItinerarySelect
    const indexItinerary = state.itinerarySourceTypeSelected.index

    var block,
      parentBlock
    switch (data.parent.status) {
      case 'Highlights':
        block = state.opportunity[data.dataRootKey][indexItinerary].highlights
        break

      case 'Included':
        block = state.opportunity[data.dataRootKey][indexItinerary].whatsincluded
        break

      case 'Not Included':
        block = state.opportunity[data.dataRootKey][indexItinerary].whatsnotincluded
        break

      default:
        break
    }
    parentBlock = block.find(b => b.id === Number(data.parent.id))
    if (!parentBlock) {
      parentBlock = block.find(i => String(i.old) === String(data.parent.old))
    }
    var toDelete = parentBlock.items.findIndex(b => (b.id === Number(data.child.id)))
    if (toDelete > -1) {
      parentBlock.items[toDelete].id ? parentBlock.items[toDelete].status = -1 : parentBlock.items.splice(toDelete, 1)
    }
    var toDeleteByTitle = parentBlock.items.findIndex(
      b => (!data.child.id && b.items === data.child.items)
    )
    if (toDeleteByTitle > -1) {
      parentBlock.items.splice(toDeleteByTitle, 1)
    }
  },

  TEMP_REMOVE_ITEM_SALES_FLYER (state, data) {
    var block,
      parentBlock
    switch (data.parent.status) {
      case 'Highlights':
        block = state.opportunity[data.dataRootKey].highlights
        break

      case 'Included':
        block = state.opportunity[data.dataRootKey].whatsincluded
        break

      case 'Not Included':
        block = state.opportunity[data.dataRootKey].whatsnotincluded
        break

      default:
        break
    }
    parentBlock = block.find(b => b.id === Number(data.parent.id))
    if (!parentBlock) {
      parentBlock = block.find(i => String(i.old) === String(data.parent.old))
    }
    var toDelete = parentBlock.items.findIndex(b => (b.id === Number(data.child.id)))
    if (toDelete > -1) {
      parentBlock.items[toDelete].id ? parentBlock.items[toDelete].status = -1 : parentBlock.items.splice(toDelete, 1)
    }
    var toDeleteByTitle = parentBlock.items.findIndex(
      b => (!data.child.id && b.items === data.child.items)
    )
    if (toDeleteByTitle > -1) {
      parentBlock.items.splice(toDeleteByTitle, 1)
    }
  },

  TEMP_UPDATE_ITEM (state, data) {
    // ItinerarySelect
    const indexItinerary = state.itinerarySourceTypeSelected.index

    var block,
      parentBlock
    switch (data.parent.status) {
      case 'Highlights':
        block = state.opportunity[data.dataRootKey][indexItinerary].highlights
        break

      case 'Included':
        block = state.opportunity[data.dataRootKey][indexItinerary].whatsincluded
        break

      case 'Not Included':
        block = state.opportunity[data.dataRootKey][indexItinerary].whatsnotincluded
        break

      default:
        break
    }
    parentBlock = block.find(b => b.id === Number(data.parent.id))
    if (!parentBlock) {
      parentBlock = block.find(i => String(i.old) === String(data.parent.old))
    }
    var toUpdate = parentBlock.items.find(b => (b.id === Number(data.child.id)))
    if (!toUpdate) {
      toUpdate = parentBlock.items.find(b => String(b.old) === String(data.child.old))
    }
    toUpdate.items = data.new
  },

  TEMP_UPDATE_ITEM_SALES_FLYER (state, data) {
    var block,
      parentBlock
    switch (data.parent.status) {
      case 'Highlights':
        block = state.opportunity[data.dataRootKey].highlights
        break

      case 'Included':
        block = state.opportunity[data.dataRootKey].whatsincluded
        break

      case 'Not Included':
        block = state.opportunity[data.dataRootKey].whatsnotincluded
        break

      default:
        break
    }
    parentBlock = block.find(b => b.id === Number(data.parent.id))
    if (!parentBlock) {
      parentBlock = block.find(i => String(i.old) === String(data.parent.old))
    }
    var toUpdate = parentBlock.items.find(b => (b.id === Number(data.child.id)))
    if (!toUpdate) {
      toUpdate = parentBlock.items.find(b => String(b.old) === String(data.child.old))
    }
    toUpdate.items = data.new
  },

  TEMP_SAVE_SELECT_IMAGES (state, items) {
    if (Array.isArray(state.opportunity.images) && state.opportunity.images.length === 0) {
      state.opportunity.images = {
        cover_image: null,
        cover_page: null,
        images_page: null,
        background: null,
        agent_quote_pdf: null,
        agent_quote_web_link: null
      }
    }

    for (const item of items) {
      if (item.images && Array.isArray(item.images) && item.images.length > 0) {
        state.opportunity.images[item.type] = item.images
      }
    }
  },
  TEMP_SAVE_SELECT_IMAGES_FLYER (state, payload) {
    if (Array.isArray(state.opportunity.consumer_section.images) && state.opportunity.consumer_section.images.length === 0) {
      state.opportunity.consumer_section.images = {
        cover_image: null,
        cover_page: null,
        images_page: null,
        background: null
      }
    }
    if (payload.coverPage && Array.isArray(payload.coverPage) && payload.coverPage.length > 0) {
      state.opportunity.consumer_section.images.cover_page = payload.coverPage
    }
    if (payload.imagesPage && Array.isArray(payload.imagesPage) && payload.imagesPage.length > 0) {
      state.opportunity.consumer_section.images.images_page = payload.imagesPage
    }
  },
  TEMP_SAVE_FLYER_OPTION(state, payload) {
    state.opportunity.consumer_section.flyer_option = payload.flyer_option
  },
  TEMP_SAVE_WEB_LINK (state, items) {
    if (!state.opportunity.images || state.opportunity.images.length === 0) {
      state.opportunity.images = {
        cover_image: null,
        cover_page: null,
        images_page: null,
        background: null,
        agent_quote_pdf: null,
        agent_quote_web_link: null
      }
    }

    for (const item of items) {
      if (item.images && Array.isArray(item.images) && item.images.length > 0) {
        state.opportunity.images[item.type] = item.images
      }
    }
  },

  TEMP_SAVE_LANDING_PAGE_OR_GUEST_DOCUMENTATION (state, payload) {
    const dataRootKey = payload.dataRootKey
    if (
      state.opportunity[dataRootKey] &&
      Array.isArray(state.opportunity[dataRootKey].images) &&
      !state.opportunity[dataRootKey].images.length) {
      state.opportunity[dataRootKey].images = {
        cover_image: null,
        cover_page: null,
        images_page: null,
        background: null
      }
    }
    const sourceBackground = state.opportunity[dataRootKey].images.background
    if (sourceBackground && Array.isArray(sourceBackground) && sourceBackground.length > 0) {
      sourceBackground.forEach((image, index) => {
        state.opportunity[dataRootKey].images.background[index]['status'] = -1
      })
    }
    if (payload.background && Array.isArray(payload.background) && payload.background.length > 0) {
      if (state.opportunity[dataRootKey].images.background === null || state.opportunity[dataRootKey].images.background === undefined) {
        state.opportunity[dataRootKey].images.background = []
      }
      payload.background.forEach((image, index) => {
        if (image) {
          state.opportunity[dataRootKey].images.background.push(image)
        }
      })
    }
  },

  TEMP_SAVE_COMPLETE_QUOTE  (state, payload) {
    if (state.opportunity) {
      state.opportunity.request_form.properties_request_form.id_stage_supplier = Number(payload)
    }
  },
  TEMP_ADD_MEAL (state, payload) {
    const indexItinerary = state.itinerarySourceTypeSelected.index
    if (payload.indexDay > -1 && state.opportunity && state.opportunity.itineraries) {
      if (state.opportunity.itineraries[indexItinerary] && state.opportunity.itineraries[indexItinerary].days && state.opportunity.itineraries[indexItinerary].days[payload.indexDay] && !state.opportunity.itineraries[indexItinerary].days[payload.indexDay].meals) {
        state.opportunity.itineraries[indexItinerary].days[payload.indexDay].meals = []
      }
      state.opportunity.itineraries[indexItinerary].days[payload.indexDay].meals
        .push({ id: null, mealsday: '' })
    }
  },

  TEMP_REMOVE_MEAL (state, payload) {
    const indexItinerary = state.itinerarySourceTypeSelected.index
    if (payload.indexDay > -1) {
      let sourceMeal = state.opportunity.itineraries[indexItinerary].days[payload.indexDay].meals.find(meal => meal.id === payload.mealId)
      sourceMeal.status = -1
      if (!payload.mealId) {
        state.opportunity.itineraries[indexItinerary].days[payload.indexDay].meals.splice(payload.index, 1)
      }
    }
  },

  TEMP_UPDATE_MEAL (state, payload) {
    const indexItinerary = state.itinerarySourceTypeSelected.index
    if (payload.indexDay > -1) {
      let sourceMeals = state.opportunity.itineraries[indexItinerary].days[payload.indexDay].meals
      let sourceMeal = sourceMeals.filter(meal => payload.mealId && meal.id === payload.mealId)
      if (Number(sourceMeal.mealId) > 0) {
        sourceMeal = sourceMeal.shift()
      } else {
        sourceMeal = sourceMeals[payload.indexMeal]
      }
      sourceMeal.mealsday = payload.newValue
    }
  },

  TEMP_SAVE_TEMPLATE_SETTINGS (state, payload) {
    state.opportunity.template_settings= payload
  },

  TEMP_SAVE_OPPORTUNITY_SETTINGS (state, payload) {
    state.opportunity.opportunity_settings = payload
  },

  TEMP_SAVE_LINE_BREAKS_NUMBER (state, payload) {
    if (!state.opportunity.template_content) {
      state.opportunity.template_content = []
    }
    if (Array.isArray(payload.days) && payload.days.length > 0) {
      const templateContentByTypeSelected = state.opportunity.template_content
        .find(tc => tc.type === payload.type)
      let templateContentItem = {
        id: null,
        days: [],
        type: payload.type
      }
      if (templateContentByTypeSelected && templateContentByTypeSelected.id) {
        templateContentItem.id = templateContentByTypeSelected.id
      }
      if (
        templateContentByTypeSelected &&
        Array.isArray(templateContentByTypeSelected.days) &&
        templateContentByTypeSelected.days.length > 0
      ) {
        templateContentItem.days = templateContentByTypeSelected.days.map(d => {
          const fd = payload.days.find(pd => pd.startday === d.startday)
          if (fd) {
            d.line_breaks_number = Number(fd.line_breaks_number)
            return d
          } else {
            d.line_breaks_number = 0
            return d
          }
        })
      } else {
        payload.days.forEach(day => {
          templateContentItem.days.push({
            id: null,
            startday: day.startday,
            line_breaks_number: Number(day.line_breaks_number)
          })
        })
      }
      if (templateContentItem && templateContentItem.id) {
        const indexToReplace = state.opportunity.template_content
          .findIndex(tc => tc.id === templateContentItem.id && tc.type === payload.type)
        state.opportunity.template_content.splice(indexToReplace, 1, templateContentItem)
      } else {
        state.opportunity.template_content.push(templateContentItem)
      }
    }
  },

  TEMP_SAVE_LINE_BREAKS_NUMBER_deprecated (state, payload) {
    const indexItinerary = state.itinerarySourceTypeSelected.index
    if (Array.isArray(payload) && payload.length > 0) {
      payload.forEach((day, index) => {
        const sourceDay = state.opportunity.itineraries[indexItinerary].days[index]
        sourceDay.line_breaks_number = Number(day.line_breaks_number)
      })
    }
  },

  TEMP_IMPORT_INCLUSIONS_TO_TRIP_INCLUSIONS (state, payload) {
    const indexItinerary = 0 // state.itinerarySourceTypeSelected.index

    if (!state.opportunity.consumer_section.highlights) {
      state.opportunity.consumer_section.highlights = []
    }

    if (!state.opportunity.consumer_section.whatsincluded) {
      state.opportunity.consumer_section.whatsincluded = []
    }

    state.opportunity.consumer_section.highlights.forEach((item, index) => {
      state.opportunity.consumer_section.highlights[index].status = -1
    })

    state.opportunity.consumer_section.whatsincluded.forEach((item, index) => {
      state.opportunity.consumer_section.whatsincluded[index].status = -1
    })

    state.opportunity.consumer_section.highlights.push(...JSON.parse(JSON.stringify(state.opportunity.itineraries[indexItinerary].highlights)))
    state.opportunity.consumer_section.whatsincluded.push(...JSON.parse(JSON.stringify(state.opportunity.itineraries[indexItinerary].whatsincluded)))

    state.opportunity.consumer_section.highlights.forEach((item, index) => {
      if (!state.opportunity.consumer_section.highlights[index].status) {
        state.opportunity.consumer_section.highlights[index].id = null
        item.items.forEach((subItem, subIndex) => {
          state.opportunity.consumer_section.highlights[index].items[subIndex].id = null
        })
      }
    })

    state.opportunity.consumer_section.whatsincluded.forEach((item, index) => {
      if (!state.opportunity.consumer_section.whatsincluded[index].status) {
        state.opportunity.consumer_section.whatsincluded[index].id = null
        item.items.forEach((subItem, subIndex) => {
          state.opportunity.consumer_section.whatsincluded[index].items[subIndex].id = null
        })
      }
    })
  },

  TEMP_EXPORT_COVER_PAGE_FROM_OPPORTUNITY_TO_CONSUMER_SECTION (state, items) {
    if (Array.isArray(state.opportunity.consumer_section.images) && state.opportunity.consumer_section.images.length === 0) {
      state.opportunity.consumer_section.images = {
        cover_page: [],
        images_page: [],
        background: []
      }
    }

    for (const item of items) {
      const payload = item.images.at(-1)

      if (payload.asset_id) {
        state.opportunity.consumer_section.images[item.type] = getValidatedImages(
          state.opportunity.consumer_section.images[item.type],
          { ...payload, id: null },
          1
        );
      }
    }
  },

  TEMP_EXPORT_IMAGES_PAGE_FROM_OPPORTUNITY_TO_CONSUMER_SECTION (state, items = []) {
    if (Array.isArray(state.opportunity.consumer_section.images) && state.opportunity.consumer_section.images.length === 0) {
      state.opportunity.consumer_section.images = {
        cover_page: [],
        images_page: [],
        background: []
      }
    }

    for (const item of items) {
      const payload = item.images

      if (payload.asset_id) {
        state.opportunity.consumer_section.images[item.type] = getValidatedImages(
          state.opportunity.consumer_section.images[item.type],
          { ...payload, id: null },
          1
        )
      }
    }
  },

  TEMP_EXPORT_BACKGROUND_FROM_OPPORTUNITY_TO_CONSUMER_SECTION (state, items) {
    if (Array.isArray(state.opportunity.consumer_section.images) && state.opportunity.consumer_section.images.length === 0) {
      state.opportunity.consumer_section.images = {
        cover_page: [],
        images_page: [],
        background: [],
        agent_quote_pdf: [],
        agent_quote_web_link: []
      }
    }

    for (const item of items) {
      const payload = item.images.at(-1)
      if (payload.asset_id) {
        state.opportunity.consumer_section.images[item.type] = getValidatedImages(
          state.opportunity.consumer_section.images[item.type],
          { ...payload, id: null },
          1
        );
      }
    }
  },

  TEMP_EXPORT_LINE_BREAKS_NUMBER_FROM_QUOTE_PDF_TO_FLYER_PDF (state, payload) {
    const FROM = payload.type
    const TO = 'flyer_pdf'
    const getSource = (data, type) => data.find(tc => tc.type === type)

    const templateContent = state.opportunity.template_content

    if (state.opportunity.template_content) {
      const templateContentTypeQuote = getSource(templateContent, FROM)
      const templateContentTypeFlyer = getSource(templateContent, TO)

      if (
        templateContentTypeQuote &&
        Array.isArray(templateContentTypeQuote.days) &&
        templateContentTypeQuote.days.length > 0
      ) {
        if (
          templateContentTypeFlyer &&
          Array.isArray(templateContentTypeFlyer.days) &&
          templateContentTypeFlyer.days.length > 0
        ) {
          templateContentTypeFlyer.days.forEach(day => {
            const dayFound = templateContentTypeQuote.days
              .find(fd => fd.startday === day.startday)
            if (dayFound) {
              day.line_breaks_number = dayFound.line_breaks_number
            }
          })
        } else {
          let templateContentItem = { id: null, days: [], type: TO }
          templateContentTypeQuote.days.forEach(day => {
            templateContentItem.days.push({
              id: null,
              startday: day.startday,
              line_breaks_number: Number(day.line_breaks_number)
            })
          })
          state.opportunity.template_content.push(templateContentItem)
        }
      }
    }
  },

  SET_SOURCE_TYPES_DATA (state, data) {
    state.sourceTypes = data.data.sourceTypes
      .map(f => ({ text: f.text, value: f.id, label: f.label }))
    // Setting the first source type value by default
    if (state.sourceTypes[0]) {
      state.itinerarySourceTypeSelected = {
        index: 0,
        value: state.sourceTypes[0].value
      }
    }
  },

  SET_SOURCE_TYPE_SELECTED (state, payload) {
    state.itinerarySourceTypeSelected = {
      index: payload.indexItinerary,
      ...payload.sourceType
    }
  },

  SET_SIGNATURE (state, data) {
    state.signature = data
  }
}
